import { saveAs } from "file-saver";
import { message } from "antd";

/**
 * Function to download table data as CSV.
 * @param {Array} dataSource - The data to be converted to CSV.
 * @param {Array} columns - The column definitions for the table.
 * @param {string} filename - The name of the file to be downloaded.
 */
export const downloadCSV = (dataSource, columns, filename) => {
  if (!dataSource || dataSource.length === 0) {
    message.warning("No data available to export.");
    return;
  }
  let effectiveColumns = columns;
  let effectiveFilename = filename;

  // Handle case where downloadCSV(data, filename) is called
  if (typeof columns === "string" && !filename) {
    effectiveFilename = columns;
    if (dataSource && dataSource.length > 0) {
      // Inferred columns from data keys
      effectiveColumns = Object.keys(dataSource[0]).map((key) => ({
        title: key.toUpperCase(),
        dataIndex: key,
      }));
    } else {
      effectiveColumns = [];
    }
  }

  if (!Array.isArray(effectiveColumns)) {
    console.error("downloadCSV: columns must be an array");
    return;
  }

  const csvRows = [];
  // Filter out columns that shouldn't be in CSV (like actions or specific fields)
  const filteredColumns = effectiveColumns.filter(
    (column) =>
      column.dataIndex &&
      column.dataIndex !== "fileName" &&
      column.dataIndex !== "action"
  );

  const headers = filteredColumns.map((column) => column.title);
  csvRows.push(headers.join(",")); // Add headers

  dataSource.forEach((row) => {
    const values = filteredColumns.map((column) => {
      const val = row[column.dataIndex];
      // Escape commas in values to avoid breaking CSV format
      return val !== undefined && val !== null ? `"${String(val).replace(/"/g, '""')}"` : "";
    });
    csvRows.push(values.join(",")); // Add row values
  });

  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, effectiveFilename || "download.csv");
};
